export default "__VITE_ASSET__957085f5__"